import axiosClient from "@/api/common/axiosClient.ts";
import {
  CreateNewSupportTicketFormData,
  SupportTicket,
} from "@/types/supportTicket.ts";

export const openTicket = (data: CreateNewSupportTicketFormData) => {
  return axiosClient.post<SupportTicket>("support-tickets/new/", data);
};
